import { createContext, useEffect, useReducer } from "react";

import axios from "../components/utils/axios";
import {
  setSession,
  setAccount,
  Session_AccountId,
} from "../components/utils/jwt";
import { useLocation } from "react-router";

// Note: If you're trying to connect JWT to your own backend, don't forget
// to remove the Axios mocks in the `/src/index.js` file.

const INITIALIZE = "INITIALIZE";

const SIGN_IN = "SIGN_IN";
const SIGN_OUT = "SIGN_OUT";
const SIGN_UP = "SIGN_UP";
const SIDE_BAR = "SIDE_BAR";

const initialState = {
  isAuthenticated: false,
  isInitialized: false,

  isAuthenticatedBS: false,
  isInitializedBS: false,
  user: [],
  account: [],
  sidebarOpen: false,
};

const URLBASESSO = process.env.REACT_APP_SSO_URL;
const URLBASE = process.env.REACT_APP_URL_FLOW_END;

const SSOReducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
        account: action.payload.user,
        isInitializedBS: action.payload.isInitializedBS,
      };

    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    case SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };

    case SIDE_BAR:
      return {
        ...state,
        sidebarOpen: action.payload.sidebarOpen,
      };

    default:
      return {
        ...state,
      };
  }
};

const SSOContext = createContext(null);

function SSOProvider({ children }) {
  let location = useLocation();

  const [state, dispatch] = useReducer(SSOReducer, initialState);
  useEffect(() => {
    const initialize = async () => {
      checkAuth();
    };

    initialize();
  }, []);

  const HandleSideBar = async () => {
    dispatch({
      type: SIDE_BAR,
      payload: {
        sidebarOpen: !state.sidebarOpen,
      },
    });
  };

  const checkAuth = async () => {
    try {
      const accessToken = window.localStorage.getItem("accessToken");
      const AccountId = window.localStorage.getItem(Session_AccountId);

      if (AccountId) {
        setAccount(AccountId);
      }

      if (accessToken) {
        setSession(accessToken);
        let userValid = false;
        const response = await axios.get(URLBASE + "/api/v1/auth");
        console.log(response);
        if (response) {
          userValid = response.data.user ? true : false;
        }


        const { user, account } = response.data;

        dispatch({
          type: INITIALIZE,
          payload: {
            isAuthenticated: userValid,
            user: user,
            account: account ? account : [],
            isInitializedBS: AccountId ? true : false,
            isInitialized: true,
          },
        });
      } else {
        setSession(null);
        dispatch({
          type: INITIALIZE,
          payload: {
            isAuthenticated: false,
            isInitialized: true,
            user: null,
          },
        });
      }
    } catch (err) {
      setSession(null);
      console.error(err);
      dispatch({
        type: INITIALIZE,
        payload: {
          isAuthenticated: false,
          isInitialized: true,
          user: null,
        },
      });
    }
  };

  const signIn = async (email, password) => {
    let responsedata = null;

    const response = await axios
      .post(URLBASESSO + "/user/auth", {
        email,
        password,
      })
      .catch((error) => {
        if (error) {
          responsedata = error;
        }
      });
    if (response) {
      responsedata = response.data;

      const { token, accounts } = response.data;

      window.localStorage.setItem("accessToken", token);
      window.localStorage.setItem(Session_AccountId, accounts[0]);
    }

    return responsedata;
  };

  const getApi = async (url, data) => {
    let responsedata = null;
    const accessToken = window.localStorage.getItem("accessToken");
    const AccountId = window.localStorage.getItem(Session_AccountId);

    if (AccountId) {
      setAccount(AccountId);
    }
    if (accessToken) {
      setSession(accessToken);
    }

    const submitAxios = await axios
      .get(URLBASE + url, { params: data })
      .catch((error) => {
        if (error) {
          responsedata = error;
        }
      });
    if (submitAxios) {
      responsedata = submitAxios.data;
    }

    return responsedata;
  };

  const postApi = async (url, data) => {
    let responsedata = null;

    const accessToken = window.localStorage.getItem("accessToken");
    const AccountId = window.localStorage.getItem(Session_AccountId);

    if (AccountId) {
      setAccount(AccountId);
    }
    if (accessToken) {
      setSession(accessToken);
    }

    const submitAxios = await axios.post(URLBASE + url, data).catch((error) => {
      if (error) {
        responsedata = error;
      }
    });
    if (submitAxios) {
      responsedata = submitAxios.data;
    }

    return responsedata;
  };

  const patchApi = async (url, data) => {
    let responsedata = null;

    const accessToken = window.localStorage.getItem("accessToken");
    const AccountId = window.localStorage.getItem(Session_AccountId);

    if (AccountId) {
      setAccount(AccountId);
    }
    if (accessToken) {
      setSession(accessToken);
    }

    const submitAxios = await axios.patch(URLBASE + url, data).catch((error) => {
      if (error) {
        responsedata = error;
      }
    });
    if (submitAxios) {
      responsedata = submitAxios.data;
    }

    return responsedata;
  };

  const deleteApi = async (url, data) => {
    let responsedata = null;

    const accessToken = window.localStorage.getItem("accessToken");
    const AccountId = window.localStorage.getItem(Session_AccountId);

    if (AccountId) {
      setAccount(AccountId);
    }
    if (accessToken) {
      setSession(accessToken);
    }

    const submitAxios = await axios.delete(URLBASE + url, data).catch((error) => {
      if (error) {
        responsedata = error;
      }
    });
    if (submitAxios) {
      responsedata = submitAxios.data;
    }

    return responsedata;
  };

  const resetPassword = async (email) => {
    let errorMsg;
    const response = await axios
      .post(URLBASE + "/user/auth/reset/generatecode", {
        email,
      })
      .catch((error) => {
        if (error) {
          errorMsg = error;
        }
      });

    if (response) {
      const { success } = response.data;

      return success;
    } else {
      return errorMsg;
    }
  };

  const resetPasswordStep2 = async (email, password, token) => {
    const response = await axios.post(URLBASE + "/user/reset/password", {
      email,
      password,
      token,
    });
    if (response) {
      const { success } = response.data;

      if (success) {
      }
    } else {
      return response;
    }
  };

  const signUp = async (fullname, email, password, phone) => {
    let responsedata = null;

    const submitAxios = await axios
      .post(URLBASESSO + "/signup", {
        name: fullname,
        email,
        password,
        phone,
      })
      .catch((error) => {
        if (error) {
          responsedata = error;
        }
      });
    if (submitAxios) {
      responsedata = submitAxios.data;

      const { token, accounts } = submitAxios.data;

      window.localStorage.setItem("accessToken", token);

      window.localStorage.setItem(Session_AccountId, accounts[0]);
    }

    return responsedata;
  };

  const signOut = async () => {

    window.localStorage.setItem("accessToken", null);

    window.localStorage.setItem(Session_AccountId, null);

    window.location.href = '/sign-in';


    setSession(null);
    dispatch({ type: SIGN_OUT });


  };

  return (
    <SSOContext.Provider
      value={{
        ...state,
        method: "jwt",
        signIn,
        signOut,
        signUp,
        resetPassword,
        resetPasswordStep2,
        getApi,
        patchApi,
        postApi,
        deleteApi,
        HandleSideBar,
      }}
    >
      {children}
    </SSOContext.Provider>
  );

  // Fim auth provider
}

export { SSOContext, SSOProvider };
